import { render, staticRenderFns } from "./UnicoreIndex.vue?vue&type=template&id=accd4b26&scoped=true"
import script from "./UnicoreIndex.vue?vue&type=script&lang=js"
export * from "./UnicoreIndex.vue?vue&type=script&lang=js"
import style0 from "./UnicoreIndex.vue?vue&type=style&index=0&id=accd4b26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accd4b26",
  null
  
)

export default component.exports